import React from "react";
import Layout from "../../components/Layout";
import ClaudeAgentChat from "./ClaudeAgentChat";
import "./ClaudeAgentLanding.css";

/**
 * Entry point at /claude-agent — renders the full workspace shell. The active
 * environment auto-loads to the user's default (Personal). An agent is auto-
 * picked from the available list if none has been chosen yet.
 */
export default function ClaudeAgentLanding() {
  return (
    <Layout>
      <ClaudeAgentChat />
    </Layout>
  );
}
